import SportBadge from 'components/SportBadge';
import ProfileSection from '../ProfileSection';
import type { PlayerProfileExperience } from 'screens/PlayerProfile/types';

interface Props {
  experiences: PlayerProfileExperience[];
  isViewerProfile: boolean;
  onEdit?: () => void;
}

export default function ProfileExperience({ experiences, isViewerProfile, onEdit }: Props) {
  return (
    <ProfileSection
      title="My experience"
      isViewerProfile={isViewerProfile}
      onEdit={onEdit}
      isEmpty={!experiences.length}
      emptyLabel="Add sports and ratings"
      // Sits under the About Me heading in the design, so it takes the smaller level.
      titleSize="sm"
    >
      <div className="flex flex-wrap items-center gap-ds-md">
        {experiences.map(({ key, sport, detail }) => (
          <SportBadge key={key} sport={sport} variant="neutral" size="sm" detail={detail} />
        ))}
      </div>
    </ProfileSection>
  );
}
